/* «Weiterlesen»: kürzt lange Texte auf eine Vorschau mit Ausblend-Verlauf.
   Ohne JS bleibt der volle Text sichtbar; kurze Texte bekommen keinen Button. */
(function () {
  'use strict';
  document.querySelectorAll('[data-readmore]').forEach(function (box) {
    var body = box.querySelector('[data-readmore-body]');
    var btn = box.querySelector('[data-readmore-toggle]');
    if (!body || !btn) return;

    var limit = parseInt(getComputedStyle(box).getPropertyValue('--desc-clamp'), 10) || 240;
    /* Etwas Toleranz: knapp längere Texte lieber ganz zeigen als 2 Zeilen verstecken */
    if (body.scrollHeight <= limit + 80) return;

    box.classList.add('is-clamped');
    btn.hidden = false;

    btn.addEventListener('click', function () {
      var open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.dataset.labelLess : btn.dataset.labelMore;
      /* Beim Zuklappen zum Anfang der Beschreibung zurück, damit man nicht «verloren» ist */
      if (!open && box.getBoundingClientRect().top < 0) {
        box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();
